<template>
  <el-select
    ref="selector"
    v-model="internalValue"
    :clearable="clearable"
    :filter-method="handleFilterSearchChange"
    :filterable="filterable"
    :placeholder="placeholder"
    :popper-class="popperClass"
    collapse-tags
    size="mini"
    v-bind="$attrs"
    @focus="setTabIndex"
    @input="setTabIndex"
    @keydown="setTabIndex"
    @keyup="setTabIndex"
    @blur.prevent="setTabIndex"
    @visible-change="handleVisibleChange"
  >
    <el-option
      v-for="item in filteredItems"
      :key="item.key"
      :label="item.label"
      :value="item.value"
    >
      <span class="label-left" v-html="highlight(item.label)" />
      <span
        v-show="item.description"
        class="label-right mr-3"
        v-html="highlight(renderDescription(item.description))"
      >
      </span>
    </el-option>
  </el-select>
</template>

<script>
import filterMixin from "@/mixins/filter";
import escapeRegExp from "@/utils/regexp";

export default {
  name: "SingleSelect",

  mixins: [filterMixin],

  inheritAttrs: false,

  props: {
    value: {
      type: [Number, String, Object],
      required: false,
    },
    popperClass: {
      type: [String, Object, Array],
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
    itemLabel: {
      type: String,
      default: "label",
    },
    itemDescription: {
      type: String,
      default: null,
    },
    itemAsValue: {
      type: Boolean,
    },
    itemValue: {
      type: String,
      default: "id",
    },
    placeholder: {
      type: String,
      default: "Seleccionar",
    },
    descriptionRenderer: {
      type: Function,
    },
    clearable: {
      type: Boolean,
    },
    tabindex: {
      type: String,
    },
    filterable: {
      type: Boolean,
    },
  },

  data() {
    return {
      textFilter: "",
    };
  },

  computed: {
    formattedItems() {
      return this.items.map((item) => {
        return {
          key: this.itemAsValue ? JSON.stringify(item) : item[this.itemValue],
          value: this.itemAsValue ? item : item[this.itemValue],
          label: item[this.itemLabel],
          description: this.itemDescription ? item[this.itemDescription] : "",
        };
      });
    },

    filteredItems() {
      const items = this.formattedItems;
      if (!this.textFilter) {
        return items;
      }
      const text = this.textFilter;
      const regexp = new RegExp(escapeRegExp(text), "i");
      return items.filter((item) => {
        let text = item.label;
        if (item.description) {
          text = `${text} ${item.description}`;
        }
        return text.match(regexp);
      });
    },

    internalValue: {
      get() {
        return this.value;
      },
      set(v, oldV) {
        if (oldV !== v) {
          this.fireInput(v);
        }
      },
    },
  },

  mounted() {
    this.interval = setInterval(() => {
      this.setTabIndex();
    }, 100);
  },

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  methods: {
    setTabIndex() {
      if (this.$refs.selector && this.tabindex) {
        const input = this.$refs.selector.$el.querySelector("input");
        if (input) {
          input.tabIndex = this.tabindex;
        }
      }
    },

    handleFilterItemsChange(text) {
      this.textFilter = text;
    },

    handleFilterSearchChange(text) {
      this.textFilter = text;
    },

    fireInput(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },

    renderDescription(description) {
      if (this.descriptionRenderer) {
        return this.descriptionRenderer(description);
      }
      return description;
    },

    async handleVisibleChange(visible) {
      if (visible && this.items.length < 1) {
        this.$emit("fetch");
      }
      if (!visible && !this.value && this.isRequired && this.textFilter !== "") {
        this.$message({
          type: "error",
          message: "No se ha seleccionado ningún elemento",
        });
      }
      this.textFilter = "";
    },
  },
};
</script>

<style>
.label-left {
  float: left;
  line-height: 16px;
  margin: 9px 0;
  /* width: 75%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.label-right {
  float: right;
  overflow: hidden;
  color: #8492a6;
  font-size: 13px;
  line-height: 16px;
  margin: 9px 0 9px 10px;
}

.not-set .el-input__inner {
  background: #ff000014;
}
</style>
